import React, { useEffect, useState, useContext } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import userApi from '_api/user'
import { getUserInfo, setUserInfo } from '_utils/localData'
import { DeviceUserContext } from '_context/DeviceUserContext'
import { DESKTOP } from '_utils/constant'
import HeroCard from './components/HeroCard'
import QuickActions from './components/QuickActions'
import LogoutCard from './components/LogoutCard'
import FeedbackCard from './components/FeedbackCard'
import NotificationsTab from './Notifications'
import ProfileTab from './Profile'
import SecurityTab from './Security'
import AddressesTab from './Addresses'
import './style.scss'

const UserV2 = () => {
  const { checkDeviceUser } = useContext(DeviceUserContext) || {}
  const isDesktop = checkDeviceUser === DESKTOP
  const [currentUser, setCurrentUser] = useState(() => getUserInfo() || {})
  const [unreadCount, setUnreadCount] = useState(0)
  const isPremium = Boolean(currentUser?.isUsingFeature)

  useEffect(() => {
    const cachedUser = getUserInfo()
    if (cachedUser && Object.keys(cachedUser).length > 0) {
      setCurrentUser(cachedUser)
    }

    userApi
      .getUser()
      .then(({ msgResp }) => {
        if (msgResp) {
          setCurrentUser(msgResp)
          setUserInfo(msgResp)
        }
      })
      .catch(() => {})
  }, [])

  return (
    <div className={`user-v2-container ${isDesktop ? 'is-desktop' : ''}`}>
      <HeroCard
        currentUser={currentUser}
        onUserUpdated={setCurrentUser}
        isPremium={isPremium}
      />

      <QuickActions unreadCount={unreadCount} />

      <div className='page-content'>
        <Switch>
          <Route
            path='/user/profile'
            render={(props) => (
              <NotificationsTab {...props} onUnreadCountChange={setUnreadCount} />
            )}
          />
          <Route
            path='/user/update'
            render={(props) => (
              <ProfileTab
                {...props}
                currentUser={currentUser}
                onUserUpdated={setCurrentUser}
              />
            )}
          />
          <Route path='/user/change-password' component={SecurityTab} />
          <Route path='/user/addresses' component={AddressesTab} />
          <Redirect exact from='/user' to='/user/profile' />
          <Route
            render={(props) => (
              <NotificationsTab {...props} onUnreadCountChange={setUnreadCount} />
            )}
          />
        </Switch>

        <LogoutCard />
        <FeedbackCard />
      </div>
    </div>
  )
}

export default UserV2
